import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Clock, Mail, Home as HomeIcon } from 'lucide-react';

const PendingApprovalPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-rose-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8" data-testid="pending-approval-page">
          <div className="w-16 h-16 bg-amber-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <Clock className="w-8 h-8 text-amber-600" />
          </div>

          <h1 className="text-2xl font-bold text-slate-800 mb-2">Registration Pending</h1>
          <p className="text-slate-500 mb-6">
            Thank you for registering! Your account is currently under review by our team.
          </p>

          <div className="bg-blue-50 border border-blue-100 rounded-xl p-4 mb-6 text-left">
            <div className="flex items-start gap-3">
              <Mail className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-sm font-medium text-blue-800">What happens next?</p>
                <ul className="mt-2 text-sm text-blue-700 space-y-1">
                  <li>Our admin will review your registration</li>
                  <li>You'll receive an email once approved</li>
                  <li>After approval, your free trial begins</li>
                </ul>
              </div>
            </div>
          </div>

          <p className="text-xs text-slate-400 mb-6">
            This process usually takes less than 24 hours. If you have questions, contact our support team.
          </p>

          <Link to="/">
            <Button variant="outline" className="rounded-xl">
              <HomeIcon className="w-4 h-4 mr-2" /> Back to Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PendingApprovalPage;
